import styled from "@emotion/styled";

import { Div } from "./layout";
import { P } from "./typography";

export const AdminHeaderDiv = styled(Div)`
  height: auto;
  z-index: 1000;
  background-color: ${({ theme }) => theme.palette.background.gray};
`;

// Feedback / legacy shared row grid
export const GRID_TEMPLATE_COLUMNS = "5% 20% 10% 10% 10% 35% 10%";

// # | Email | Created | Plan | App version | Message
export const GRID_TEMPLATE_COLUMNS_FEEDBACK =
  "40px minmax(200px, 1.6fr) 0.85fr 0.7fr 0.7fr minmax(260px, 2.4fr)";

// checkbox | Email | Plan | Source | Country | Push | Paywall | Created | Pets | Last app | Last Activity | 13 activity counts | Articles
export const USERS_TABLE_MIN_WIDTH = "2532px";
export const GRID_TEMPLATE_COLUMNS_USERS =
  "32px minmax(200px, 1.6fr) 64px 80px 64px 64px 80px 104px minmax(160px, 1.3fr) 88px 120px repeat(13, 100px) 100px";

export const GRID_TEMPLATE_COLUMNS_ARTICLES = "32% 16% 12% 12% 28%";

export const GRID_TEMPLATE_COLUMNS_LOOKUPS = "30% 18% 10% 27% 15%";

// Label | ID | Category | Order | Edit
export const GRID_TEMPLATE_COLUMNS_EVENT_TYPES =
  "minmax(160px, 2fr) minmax(120px, 1.2fr) 0.9fr 70px 160px";

export const UserTableDiv = styled(Div)`
  gap: 0;
  padding: 0;
  margin: 0;
  border: 1px solid ${({ theme }) => theme.custom.grayInputs};
  border-radius: 10px;
  width: 100%;
`;

export const UserTableHeaderDiv = styled(Div)`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS};
  background-color: ${({ theme }) => theme.palette.background.gray};
  border-radius: 10px 10px 0 0;
  width: 100%;
  gap: 3px;
`;

export const UsersTableScroll = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const UsersTableFrame = styled(UserTableDiv)`
  width: 100%;
  min-width: ${USERS_TABLE_MIN_WIDTH};
`;

export const UsersTableHeaderDiv = styled(Div)`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_USERS};
  background-color: ${({ theme }) => theme.palette.background.gray};
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: auto;
  min-height: 0;
  gap: 3px;
  align-items: center;
`;

export const FeedbackTableHeaderDiv = styled(Div)`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_FEEDBACK};
  background-color: ${({ theme }) => theme.palette.background.gray};
  border-radius: 10px 10px 0 0;
  width: 100%;
  gap: 3px;
`;

export const UserColumnRowDiv = styled(P)`
  color: black;
  width: ${(props) => props.width || "auto"};
  min-width: 0;
  box-sizing: border-box;
  border-right: 1px solid ${({ theme }) => theme.custom.grayInputs};
  padding: 10px 8px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:last-child {
    border-right: none;
  }
`;

export const UserTableBodyDiv = styled.ul`
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const UserTableRowDiv = styled.li`
  display: block;
`;

export const TableRowDiv = styled.li`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS};
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayInputs};
  gap: 3px;
`;

export const UsersTableRowDiv = styled.li`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_USERS};
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayInputs};
  gap: 3px;
  align-items: center;
`;

export const UsersHeaderCell = styled(UserColumnRowDiv)`
  font-size: 11px;
  line-height: 1.25;
`;

export const UsersActivityHeaderCell = styled(UsersHeaderCell)`
  white-space: normal;
  text-overflow: unset;
  text-align: center;
  padding: 8px 4px;
`;

export const FeedbackTableRowDiv = styled.li`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_FEEDBACK};
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayInputs};
  gap: 3px;
`;

export const TableRowDivArticles = styled.li`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_ARTICLES};
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayInputs};
  gap: 3px;
`;

export const TableRowDivLookups = styled.li`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_LOOKUPS};
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayInputs};
  gap: 3px;
`;

export const TableRowDivEventTypes = styled.li`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_EVENT_TYPES};
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayInputs};
  gap: 3px;
`;


export const TableColumnDiv = styled(P)`
  color: black;
  width: ${(props) => props.width || "auto"};
  min-width: 0;
  box-sizing: border-box;
  padding: 0 8px;
  text-align: left;
  font-size: ${(props) => props.fontSize || "12px"};
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-word;
`;

export const UsersActivityCell = styled(TableColumnDiv)`
  text-align: center;
  padding: 0 4px;
  word-break: normal;
`;

export const UsersActivityLatest = styled.span`
  display: inline-block;
  min-width: 22px;
  padding: 1px 6px;
  border-radius: 999px;
  font-weight: 700;
  line-height: 1.4;
  color: ${({ theme }) => theme.palette.primary.main};
  background: #d7f3ef;
`;

/* —— Admin: event types (form UI + list cards) —— */

export const AdminEventTypesToolbar = styled(Div)`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 4px;
`;

export const AdminEventTypesCard = styled(Div)`
  width: 100%;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.custom.grayInputs};
  background: ${({ theme }) => theme.custom.white};
  box-shadow: 0 1px 8px rgba(32, 32, 32, 0.05);
  padding: ${(props) => props.padding || "12px 14px"};
  margin-bottom: 10px;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
`;

export const AdminEventTypeFieldLabel = styled.span`
  display: block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin-bottom: 3px;
  line-height: 1.2;
`;

export const AdminEventTypeTextInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 6px 10px;
  font-size: 13px;
  line-height: 1.35;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.custom.grayInputs};
  background: ${({ theme }) => theme.custom.white};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  color: ${({ theme }) => theme.palette.text.primary};
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${({ theme }) => theme.palette.text.secondary};
    opacity: 0.65;
  }

  &:hover {
    border-color: ${({ theme }) => theme.palette.text.secondary};
  }

  &:focus {
    border-color: ${({ theme }) => theme.palette.primary.main};
    box-shadow: 0 0 0 2px rgba(0, 168, 152, 0.16);
  }
`;

export const AdminEventTypeSelect = styled.select`
  width: 100%;
  box-sizing: border-box;
  padding: 6px 10px;
  font-size: 13px;
  line-height: 1.35;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.custom.grayInputs};
  background: ${({ theme }) => theme.custom.white};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  color: ${({ theme }) => theme.palette.text.primary};
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.palette.text.secondary};
  }

  &:focus {
    border-color: ${({ theme }) => theme.palette.primary.main};
    box-shadow: 0 0 0 2px rgba(0, 168, 152, 0.16);
  }
`;

/** Десктоп: ID документа + key в одну строку */
export const AdminEventTypeIdKeyRow = styled(Div)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  justify-content: flex-start;
  align-items: stretch;
  @media (min-width: 800px) {
    flex-direction: row;
    align-items: flex-end;
    gap: 12px;
    & > *:first-of-type {
      flex: 0 0 220px;
      min-width: 0;
    }
    & > *:last-child {
      flex: 1;
      min-width: 0;
    }
  }
`;

/** Десктоп: категория | порядок | URL иконки в одну строку */
export const AdminEventTypeTripleGrid = styled(Div)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  justify-content: flex-start;
  align-items: stretch;
  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: minmax(120px, 1fr) 76px minmax(160px, 2fr);
    gap: 8px 12px;
    align-items: end;
  }
`;

/** Десктоп: en | ru | sr в три колонки */
export const AdminEventTypeLangGrid = styled(Div)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  justify-content: flex-start;
  align-items: stretch;
  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px 10px;
  }
`;

export const AdminEventTypeLangBlock = styled(Div)`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.custom.grayBorder};
  background: ${({ theme }) => theme.palette.background.lightGray};
  border-left: 3px solid ${({ theme }) => theme.palette.primary.main};
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
`;

export const AdminEventTypesList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;

export const AdminEventTypesListItem = styled.li`
  list-style: none;
  border: 1px solid ${({ theme }) => theme.custom.grayInputs};
  border-radius: 10px;
  margin-bottom: 8px;
  overflow: hidden;
  background: ${({ theme }) => theme.custom.white};
  box-shadow: 0 1px 4px rgba(32, 32, 32, 0.04);
`;

export const AdminEventTypesRowSummary = styled(Div)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  padding: 8px 12px;
`;

export const AdminEventTypeBadge = styled.span`
  display: inline-block;
  padding: 2px 7px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  background: ${({ theme }) => theme.palette.background.lightGray};
  color: ${({ theme }) => theme.palette.text.secondary};
  border: 1px solid ${({ theme }) => theme.custom.grayBorder};
`;

export const AdminEventTypesExpand = styled(Div)`
  padding: 10px 12px 12px;
  border-top: 1px solid ${({ theme }) => theme.custom.grayLight};
  background: linear-gradient(
    180deg,
    rgba(0, 168, 152, 0.05) 0%,
    ${({ theme }) => theme.custom.white} 24px
  );
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
`;

export const AdminEventTypeCheckboxRow = styled(Div)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px 16px;
  align-items: center;
  justify-content: flex-start;
  padding: 2px 0 0;
  width: 100%;
`;

export const AdminEventTypeCheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.primary};
  user-select: none;

  input[type="checkbox"] {
    width: 15px;
    height: 15px;
    accent-color: ${({ theme }) => theme.palette.primary.main};
    cursor: pointer;
  }
`;

// Service | Purpose | Where | Money | Status | Notes
export const GRID_TEMPLATE_COLUMNS_DEV_SERVICES =
  "minmax(140px, 1.2fr) minmax(160px, 1.6fr) minmax(100px, 1fr) minmax(90px, 0.9fr) 90px minmax(160px, 1.6fr)";

// Priority | Service | Price | Notes | Link — fit without horizontal scroll
export const GRID_TEMPLATE_COLUMNS_COST =
  "70px minmax(88px, 0.85fr) minmax(70px, 0.65fr) minmax(160px, 2.4fr) minmax(88px, 0.8fr)";

export const DevServicesTableHeaderDiv = styled(Div)`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_DEV_SERVICES};
  background-color: ${({ theme }) => theme.palette.background.gray};
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: auto;
  min-height: 0;
  flex-shrink: 0;
  gap: 3px;
  justify-content: flex-start;
  align-items: stretch;
`;

export const TableRowDivDevServices = styled.li`
  display: grid;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS_DEV_SERVICES};
  width: 100%;
  height: auto;
  min-height: 0;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayInputs};
  gap: 3px;
  align-items: start;
`;

export const DevServicesCostCell = styled(TableColumnDiv)`
  overflow: visible;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.35;
  padding: 8px 6px;
`;

export const DevServicesCostHeaderCell = styled(UserColumnRowDiv)`
  overflow: visible;
  white-space: normal;
  word-break: break-word;
  text-overflow: unset;
  line-height: 1.3;
  padding: 8px 6px;
`;

export const DevServicesScroll = styled.div`
  width: 100%;
  height: auto;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  border: 1px solid ${({ theme }) => theme.custom.grayInputs};
  border-radius: 10px;
  box-sizing: border-box;
`;

export const DevServicesScrollInner = styled.div`
  width: max-content;
  min-width: 100%;
  height: auto;
`;

export const DevServicesStatusPill = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  background: ${({ theme, $tone }) => {
    if ($tone === 'legacy' || $tone === 'off') return theme.custom.grayInputs;
    if ($tone === 'uncertain') return '#fff3cd';
    if ($tone === 'planned') return '#e3f2fd';
    return '#e8f5e9';
  }};
  color: ${({ $tone }) => {
    if ($tone === 'legacy' || $tone === 'off') return '#616161';
    if ($tone === 'uncertain') return '#856404';
    if ($tone === 'planned') return '#1565c0';
    return '#2e7d32';
  }};
`;

export const DevServicesSectionTitle = styled.h2`
  margin: 20px 0 8px;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  text-align: left;
`;

export const DevServicesMetaList = styled(Div)`
  width: 100%;
  height: auto;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  margin-bottom: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
